import React, { useState } from "react"
import ProgressSetup from "./ProgressSetup";
import SetupGuide from "./SetupGuide";
import ModalReasonsDiscard from "../../../components/Modal/ModalReasonsDiscard";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { MdOutlineDoNotDisturbAlt } from "react-icons/md";

const initialData = [
    { name: "Contato Inválido" },
    { name: "Falha no atendimento" },
    { name: "Financeiro" },
    { name: "Produto não ofertado" },
    { name: "Sem interesse no momento" },
    { name: "Outro" },
]

const AddReasonsDiscard = ({ step = 0, totalSteps = 4, nextStep = () => { } }) => {
    const [modalReasons, setModalReasons] = useState(false)
    const title = "Padronize os motivos de perda"
    const description = "Motivos claros evitam registros genéricos e mostram onde seu processo comercial pode melhorar."
    const btnText = "Revisar motivos"

    const openModalReasons = () => {
        setModalReasons(true)
    }

    const closeModalReasons = () => {
        setModalReasons(false)
    }

    const saveReasonsDiscard = (e, _, reasons) => {
        e.preventDefault()
        api.post("/reason-discards", { reasons }).then(() => {
            nextStep()
        }).catch(err => toast.error(err?.response?.data?.message))
    }

    return (
        <>
            <ProgressSetup
                step={step}
                totalSteps={totalSteps}
                title={title}
                description={description}
                btnText={btnText}
                onClick={openModalReasons}
            >
                <SetupGuide
                    icon={<MdOutlineDoNotDisturbAlt />}
                    title="Crie uma lista simples e útil"
                    items={[
                        { title: "Revise as sugestões", description: "Disponibilizamos motivos comuns, como sem interesse, financeiro e contato inválido." },
                        { title: "Adapte à sua operação", description: "Renomeie, remova ou inclua situações que sua equipe realmente encontra." },
                        { title: "Salve a lista", description: "Ao descartar um lead, o usuário deverá selecionar um desses motivos." },
                    ]}
                    note="Prefira motivos objetivos. Detalhes específicos podem ser registrados nas anotações do lead."
                />
            </ProgressSetup>
            {modalReasons &&
                <ModalReasonsDiscard
                    closeModal={closeModalReasons}
                    isNew={true}
                    value={initialData}
                    onSubmit={saveReasonsDiscard}
                />
            }
        </>
    )
}

export default AddReasonsDiscard
